import { Dispatch } from "redux";
import {ConfirmAuthOTPActionTypes, ConfirmAuthOTPCreateAction} from "../../types/auth/confirmAuthOTP";
import axios from "axios";

interface ErrorResponse {
    code: string | number;
    message: string;
    details?: any[];
}

export const confirmAuthOTP = (data: { ident_field: string; ident_value: string; otp_code: string }): any => {
    return async (dispatch: Dispatch<ConfirmAuthOTPCreateAction>) => {
        try {
            dispatch({ type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/confirm`,
                data: data,
                withCredentials: false
            });
            if (response.data) {
                dispatch({ type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_SUCCESS, payload: response.data });
            } else {
                dispatch({ type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_SUCCESS, payload: response.status });
            }
        } catch (error: any) {

            let errorPayload: ErrorResponse = {
                code: -1,
                message: 'Unknown error occurred',
                details: [],
            };

            if (axios.isAxiosError(error)) {
                const responseData = error.response?.data;

                if (responseData?.error) {
                    errorPayload = {
                        code: responseData.error.code,
                        message: responseData.error.message,
                        details: responseData.error.details || [],
                    };
                } else if (typeof responseData === 'string') {
                    errorPayload = {
                        code: error.response?.status || -1,
                        message: responseData,
                        details: [],
                    };
                } else {
                    errorPayload = {
                        code: error.response?.status || -1,
                        message: error.message || 'Unknown error occurred',
                        details: [],
                    };
                }
            }
            dispatch({ type: ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_ERROR, payload: errorPayload });
        }
    }
}
